import React, { useState, useEffect } from "react";
import ApiCustom from "../../utils/ApiCustom";
import { CheckIcon } from "@heroicons/react/24/solid";

const PolicyModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (isOpen) {
      getData();
    }
  }, [isOpen]);

  const getData = async () => {
    ApiCustom.get("/posts-public/")
      .then((res) => {
        const policyPost = res.data?.data?.data.filter((item) => item?.category?.slug === "dieu-khoan")
        setFormData(policyPost[0]);
      })  
      .catch((err) => console.log(err));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-base-100 pb-0 rounded-lg w-3/4 max-h-[90vh] overflow-y-auto">
        <form>
          <div className="w-full">
            <div className="flex sticky top-0 bg-base-100 z-10 justify-end px-6 py-4 items-center ">
              <button
                onClick={() => onClose(false)}
                className="px-4 py-2 border rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
              >
                X
              </button>
            </div>

            <div className="flex justify-between px-6 items-center ">
              <h1 className="text-3xl font-bold mb-4">{formData?.title}</h1>
            </div>

            <div className="flow-root">
              <div className="sun-editor-editable">
                <div
                  className="prose max-w-none px-6"
                  dangerouslySetInnerHTML={{ __html: formData?.content }}
                />
              </div>
            </div>

            <div className="flex sticky bottom-0 bg-base-100 z-10 p-6 pt-4 justify-end space-x-4 mt-3">
              <button
                type="button"
                onClick={() => onClose(true)}
                className="px-4 py-2 btn border-0 bg-green-600 hover:bg-green-800 rounded btn-sm text-white"
              >
                <CheckIcon className="w-5 h-5" />
                Đồng ý
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PolicyModal;
